import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Input, Form, FormGroup, Label, Alert } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectList from '../CustomSelectList'

export default function WorkHistoryReportForm({ location, setResults }) {
  console.log('WorkHistoryReportForm rendered: ', location)

  let init = {
    groupId: '',
    plaintiffCounsel: ''
  }

  if (location) {
    // previous inputs
    const params = new URLSearchParams(location.search)
    init = JSON.parse(params.get('inputs'))
  }

  const navigate = useNavigate()
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  const [formFeedback, setFormFeedback] = useState()

  async function submitSearch() {
    console.log('WorkHistoryReportForm.submitSearch', inputs)
    inputs.plaintiffCounsel = inputs.plaintiffCounsel === 'All' ? inputs.plaintiffCounsel = '' : inputs.plaintiffCounsel
    let validInput = true
    if (!inputs.groupId && !inputs.plaintiffCounsel) {
      validInput = false
    }
    if (!validInput) {
      return setFormFeedback(<tr><td colSpan={2}><Alert className='custom-alert' color='danger' style={{display: 'block', textAlign: 'center', margin: 'auto'}}>Need either a Group Id or Plaintiff Counsel selected.</Alert></td></tr>)
    }
    const queryString = `/custom/reports.work_history?inputs=${JSON.stringify(inputs)}`
    if (setResults) {
      setResults(null)
    }
    navigate(queryString)
  }

  return (
    <div style={{ textAlign: 'center'}}>
      <div style={{ display: 'inline-block', margin: '10px auto' }}>
        <div style={{margin: '10px auto'}}>{formFeedback}</div>
        <Form inline className='work-navigate-report-form' onSubmit={handleSubmit} >
          <FormGroup className='mb-2 mr-sm-2 mb-sm-0'>
            <Label className='mr-sm-2'><b>Group ID</b></Label>
            <Input name='groupId' defaultValue={inputs.groupId} onChange={handleInputChange} />
          </FormGroup>
          <FormGroup className='mb-2 mr-sm-2 mb-sm-0'>
            <Label className='mr-sm-2'><b>Plaintiff Counsel</b></Label>
            <CustomSelectList className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="opposing_firm" name='plaintiffCounsel' defaultValue={inputs.plaintiffCounsel} />
          </FormGroup>
          <Button color="primary">Search</Button>
        </Form>
      </div>
    </div>
  )
}
